import { useMemo } from 'react'
import { Editor, Range } from '@tiptap/react'
import { cn } from '@/utils'

interface AddPartFormProps {
  query: string
  editor: Editor
  range: Range
  updateBomOnSelect: boolean
  isSelected?: boolean
}

export const AddPartForm = ({
  query,
  updateBomOnSelect,
  isSelected,
}: AddPartFormProps) => {
  const content = useMemo(
    () =>
      updateBomOnSelect ? (
        <span
          className={cn('text-left px-2 py-1 rounded-md hover:bg-slate-300', {
            'bg-slate-200 ': isSelected,
          })}
        >
          Add&nbsp;
          <span
            style={{
              padding: '2px 6px',
              borderRadius: '5px',
              backgroundColor: '#DAF2EF',
              color: 'rgb(30, 30, 30)',
            }}
          >
            {query}
          </span>
          &nbsp;to BOM?
        </span>
      ) : (
        <span
          style={{
            padding: '2px 6px',
            borderRadius: '5px',
            backgroundColor: '#DAF2EF',
            color: 'rgb(30, 30, 30)',
          }}
        >
          {query}
        </span>
      ),
    [updateBomOnSelect, query, isSelected],
  )

  return (
    <div>
      <div className="px-2 py-2 break-all">{content}</div>
    </div>
  )
}
